import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const SocialImprint = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="pt-32 pb-24 bg-zinc-950 min-h-screen selection:bg-orange-500 selection:text-zinc-950">
      <div className="container mx-auto px-6 max-w-2xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.5 }}
        >
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-5xl font-black uppercase tracking-tighter text-white mb-4">
              Social Media <span className="text-orange-500 text-2xl md:text-4xl">Impressum</span>
            </h1>
            <div className="w-16 h-1 bg-orange-500 mx-auto"></div>
          </div>

          <div className="space-y-10 text-zinc-400">
            {/* Address */}
            <section className="bg-zinc-900/50 p-6 border border-zinc-800 rounded-sm">
              <h2 className="text-white font-bold uppercase tracking-wider mb-4 border-l-4 border-orange-500 pl-4 text-sm">
                Valeri Rudt
              </h2>
              <p className="leading-relaxed">
                Westring 9a<br />
                59423 Unna<br />
                Deutschland
              </p>
            </section>

            {/* Contact */}
            <section className="bg-zinc-900/50 p-6 border border-zinc-800 rounded-sm">
              <h2 className="text-white font-bold uppercase tracking-wider mb-4 border-l-4 border-orange-500 pl-4 text-sm">
                Kontakt
              </h2>
              <p className="leading-relaxed">
                E-Mail: <a href="mailto:info@valerirudtmedia.de" className="text-orange-500 hover:text-white transition-colors">info@valerirudtmedia.de</a><br />
                Instagram: <a href="https://www.instagram.com/v.rudt/" target="_blank" rel="noreferrer" className="text-orange-500 hover:text-white transition-colors">@v.rudt</a>
              </p>
            </section>

            {/* VAT ID */}
            <section className="bg-zinc-900/50 p-6 border border-zinc-800 rounded-sm">
              <h2 className="text-white font-bold uppercase tracking-wider mb-4 border-l-4 border-orange-500 pl-4 text-sm">
                Umsatzsteuer-ID
              </h2>
              <p className="leading-relaxed">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                <span className="text-white font-mono mt-1 inline-block">DE441656171</span>
              </p>
            </section>

            {/* Responsible */}
            <section className="bg-zinc-900/50 p-6 border border-zinc-800 rounded-sm">
              <h2 className="text-white font-bold uppercase tracking-wider mb-4 border-l-4 border-orange-500 pl-4 text-sm">
                Redaktionell verantwortlich
              </h2>
              <p className="leading-relaxed">
                Valeri Rudt<br />
                Westring 9a<br />
                59423 Unna
              </p>
            </section>

            {/* DSA Section */}
            <section className="bg-zinc-900/50 p-6 border border-zinc-800 rounded-sm">
              <h2 className="text-white font-bold uppercase tracking-wider mb-4 border-l-4 border-orange-500 pl-4 text-sm">
                Digital Services Act (DSA)
              </h2>
              <p className="leading-relaxed mb-4">
                Zentrale Kontaktstelle nach der Verordnung (EU) 2022/2065:
              </p>
              <p className="mb-2">E-Mail: <span className="text-white">info@valerirudtmedia.de</span></p>
              <p className="mb-4">Sonstige Kontaktwege: <span className="text-white">Instagram DM</span></p>
              <p className="text-xs uppercase tracking-widest text-zinc-500 font-bold mb-2">Verfügbare Sprachen:</p>
              <div className="flex gap-2">
                {['Deutsch', 'Englisch', 'Russisch'].map(lang => (
                  <span key={lang} className="bg-zinc-800 text-zinc-300 px-2 py-1 text-[10px] rounded-sm border border-zinc-700">
                    {lang}
                  </span>
                ))}
              </div>
            </section>

            {/* Dispute Resolution */}
            <section className="bg-zinc-900/50 p-6 border border-zinc-800 rounded-sm">
              <h2 className="text-white font-bold uppercase tracking-wider mb-4 border-l-4 border-orange-500 pl-4 text-sm">
                Streitbeilegung
              </h2>
              <p className="leading-relaxed text-sm">
                Wir nehmen an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil. Zuständig ist die Universalschlichtungsstelle des Zentrums für Schlichtung e.V., Straßburger Straße 8, 77694 Kehl am Rhein (<a href="https://www.verbraucher-schlichter.de" target="_blank" rel="noreferrer" className="text-orange-500 underline">www.verbraucher-schlichter.de</a>).
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default SocialImprint;